import { Button, Stack, Typography } from "@mui/material";
import CustomInput from "../../components/CustomInput";

export default function GoogleTag() {
  return (
    <div
      style={{
        maxWidth: "90%",
        margin: "auto"
      }}
    >
      <Typography variant="h3">Google Tag Manager Integration</Typography>
      <Stack direction="row">
        <Typography variant="body1">Google Tag Manager</Typography>
        <small> eg. GTM-XXXXXXX</small>
      </Stack>
      <CustomInput placeholder="Enter your GTM ID here" />
      <small>
        The following events data is sent with this integration: view_item,
        add_to_cart, begin_checkout, add_paymnet_info, purchase,
        remove_from_cart.
      </small>
      <Stack direction="row" justifyContent="end">
        <Button sx={{ marginBlock: 2 }} variant="contained">
          Save
        </Button>
      </Stack>
    </div>
  );
}
